<template>
  <div class="roll_down_bar">
    <v-card>
      <v-card-title class="calc_params" style="height: 60px">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="colorblue" style="display: inline-block">
              {{ caption }}
            </div>
            <v-icon color="green darken-2" v-if="!show" @click="show = !show">
              mdi-chevron-down
            </v-icon>
            <v-icon color="green darken-2" v-if="show" @click="show = !show">
              mdi-chevron-up
            </v-icon>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="10">
            <slot name="headers"></slot>
          </v-col>
        </v-row>
      </v-card-title>
      <transition>
        <v-card v-if="show">
          <div class="borderedStyle pt-2 pb-2 pl-2">
            <v-row no-gutters class="calcParam">
              <v-col cols="12">
                <slot name="default"></slot>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </transition>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "RollDownBar",
  components: {},
  data: () => ({
    show: true,
  }),
  props: {
    caption: { type: String },
  },
  methods: {},
  created() {},
  mounted() {},
  watch: {
    show() {
      this.$emit("changeShow", this.show);
    },
  },
};
</script>
<style lang="sass" scoped>
.colorblue
  font-size: 1.075rem
</style>
